import React from 'react';
import { clipboardCopy } from '../../shared/utils';

/**
 * シェアモーダルコンポーネント
 * URLのコピーまたはメール送信の選択肢を提供するモーダル
 * 
 * @param {boolean} isOpen - モーダルの表示状態
 * @param {Function} onClose - モーダルを閉じる際のコールバック関数
 * @param {Object} shareData - シェア用のデータ（shareCode, sharePageTitle, sharePageBody）
 */
const ShareModal = ({ isOpen, onClose, shareData }) => {
  if (!isOpen) return null;

  /**
   * URLをクリップボードにコピーする処理
   * PC版とSP版の両方のURLをコピー
   */
  const handleCopy = () => {
    const copyText = `PC版 : ${window.location.origin}/share?shareCode=${shareData.shareCode}\nSP版 : ${window.location.origin}/appShare?shareCode=${shareData.shareCode}`;
    
    clipboardCopy(copyText);
    onClose(true);
  };

  /**
   * メール送信処理
   * デフォルトメールクライアントを開いてシェア情報を送信
   */
  const handleEmail = () => {
    const mailtoUrl = `mailto:?subject=${encodeURIComponent(shareData.sharePageTitle)}&body=${encodeURIComponent(shareData.sharePageBody)}`;
    window.location.href = mailtoUrl;
    onClose(false);
  };

  return (
    <div style={styles.overlay}>
      <div style={styles.modal}>
        <div style={styles.header}>
          <h3 style={styles.title}>メッセージ</h3>
        </div>
        <div style={styles.content}>
          <p style={styles.message}>シェア用URLのコピーまたはメール送信どちらにしますか？</p>
        </div>
        <div style={styles.buttons}>
          <button style={styles.button} onClick={handleCopy}>
            コピー
          </button>
          <button style={styles.button} onClick={handleEmail}>
            メール
          </button>
        </div>
      </div>
    </div>
  );
};

/**
 * シェアモーダルのスタイル定義
 * モーダル全体のレイアウトと各要素のスタイルを定義
 */
const styles = {
  // モーダルの背景オーバーレイ
  overlay: {
    position: 'fixed',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    backgroundColor: 'rgba(0, 0, 0, 0.5)',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    zIndex: 10000
  },
  // モーダル本体のコンテナ
  modal: {
    backgroundColor: 'white',
    borderRadius: '8px',
    padding: '20px',
    minWidth: '300px',
    maxWidth: '90%',
    boxShadow: '0 4px 6px rgba(0, 0, 0, 0.1)'
  },
  // ヘッダー部分
  header: {
    marginBottom: '15px'
  },
  // タイトルテキスト
  title: {
    margin: 0,
    fontSize: '18px',
    fontWeight: 'bold',
    color: '#333'
  },
  // コンテンツ部分
  content: {
    marginBottom: '20px'
  },
  // メッセージテキスト
  message: {
    margin: 0,
    fontSize: '16px',
    color: '#666',
    lineHeight: '1.5'
  },
  // ボタンコンテナ
  buttons: {
    display: 'flex',
    gap: '10px',
    justifyContent: 'flex-end'
  },
  // ボタンスタイル
  button: {
    padding: '10px 20px',
    border: 'none',
    borderRadius: '4px',
    fontSize: '14px',
    fontWeight: 'bold',
    cursor: 'pointer',
    backgroundColor: '#f93535',
    color: 'white',
    minWidth: '80px'
  }
};

export default ShareModal;
